import {RouteLang} from "./enum/route-lang.enum";

export const menuMainItems: {
    identifier: string;
    path: Record<RouteLang, string>
}[] = [
    {
        identifier: 'home',
        path: {
            [RouteLang.FR]: '/',
        },
    },
    {
        identifier: 'gift-card',
        path: {
            [RouteLang.FR]: '/bon-cadeau',
        },
    },
    {
        identifier: 'gift-card-billing-info-form',
        path: {
            [RouteLang.FR]: '/bon-cadeau/facturation',
        }
    },
    {
        identifier: 'gift-card-confirmation',
        path: {
            [RouteLang.FR]: '/bon-cadeau/retour',
        }
    }
];